// @flow
import { get } from 'lodash';
import { messageFormat } from '@clubmed/utils';

import { OFFER_SEO } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_OFFER_SEO } from 'Utils/request/requestDictionary';

function generateOfferTitle(title = '', offerName = '') {
  return messageFormat(title).format({ offerName });
}

type CMSProps = {|
  title: string,
  config: CMSContent,
  offer: { seo: { title: string } },
|};

export const offerSEOResolver = {
  name: OFFER_SEO,
  props() {
    return {
      title: (props: CMSProps) =>
        generateOfferTitle(
          props.title || get(props, 'config.offer.seo.title'),
          get(props, 'offer.name'),
        ),
      meta: (props: CMSProps) => get(props, 'offer.htmlHeader.meta', []),
    };
  },
  resolve(appContext: AppContext, props: { offerId: string } = {}) {
    const { offerId } = props;

    const query = `{
      config {
        offer {
          seo {
            title
          }
        }
      }
      offer(offerId: "${offerId}") {
        name
        htmlHeader {
          meta {
            name
            content
          }
        }
      }
    }`;

    return graphQLClient
      .runQuery(query, appContext, { requestName: LINE_OFFER_SEO })
      .catch(() => ({ offer: null }));
  },
};
